export const admin = "ADMIN";

export const rootProtectedPath = "explore";

export const departments = {
	sales_and_ops: { name: "SALES & OPERATIONS", key: "SALES_OPS" },
	ecommerce: { name: "ECOMMERCE", key: "ECOMMERCE" },
	tech: { name: "TECH", key: "TECH" },
	buying_planning: { name: "BUYING & PLANNING", key: "BUYING_PLANNING" },
	finanace_accounts: { name: "FINANCE & ACCOUNTS", key: "FINANCE_ACCOUNTS" },
	hr_admin: { name: "HR & ADMIN", key: "HR_ADMIN" },
	management: { name: "MANAGEMENT", key: "MANAGEMENT" },
	workspaces: { name: "WORKSPACES", key: "WORKSPACES" },
};

export const services = {
	users: { name: "Users", key: "USERS", path: "users", department: departments.hr_admin },
	radhamani_web_data: {
		name: "Web Data",
		key: "RADHAMANI_WEB_DATA",
		path: "radhamani_web_data",
		department: departments.hr_admin,
	},

	business_plan: {
		name: "Business Plan",
		key: "BUSINESS_PLAN",
		path: "business_plan",
		department: departments.buying_planning,
	},
	business_plan_v2: {
		name: "Business Plan",
		key: "BUSINESS_PLAN_V2",
		path: "business_plan_v2",
		department: departments.buying_planning,
	},
	reports: {
		name: "Reports",
		key: "REPORTS",
		path: "reports/SALE/thor_live_sale",
		department: departments.buying_planning,
	},
	supplier_dashboard: {
		name: "Supplier Dashboard",
		path: "supplier_dashboard",
		key: "supplier_dashboard",
		department: departments.tech,
	},
	pragma_auto_mail: {
		name: "Pragma Auto Mail",
		path: "pragma_auto_mail",
		key: "pragma_auto_mail",
		department: departments.tech,
	},
	store_recommendation: {
		name: "Store Recommendation",
		path: "store_recommendation",
		key: "store_recommendation",
		department: departments.tech,
	},
	data_hub: {
		name: "Data Hub",
		path: "data_hub",
		key: "data_hub",
		department: departments.buying_planning,
	},
	replenishment: {
		name: "Replenishment",
		path: "replenishment",
		key: "replenishment",
		department: departments.buying_planning,
	},
	shipping_partner_reco: {
		name: "Shipping Partner Reco",
		path: "shipping_partner_reco",
		key: "shipping_partner_reco",
		department: departments.ecommerce,
	},
	aop: {
		name: "Revenue AOP vs Actual",
		path: "aop",
		key: "aop",
		department: departments.management.key,
	},
	online_reco: {
		name: "Myntra Reco",
		path: "online_reco",
		key: "ONLINE_RECO",
		department: departments.finanace_accounts,
	},
	ebo_stores: { name: "Store Master", key: "EBO_STORE", path: "ebo_stores", department: departments.tech },
	mbo_stores: { name: "MBO - LFS Store", key: "MBO_LFS_STORE", department: departments.tech, path: "mbo_lfs_stores" },

	item_master: { name: "Item Master", key: "ITEM_MASTER", path: "item_master", department: departments.tech },
	production_costing: {
		name: "Production Costing",
		key: "PRODUCTION_COSTING",
		path: "production_costing",
		department: departments.finanace_accounts,
	},
	uc_vs_ginesys: {
		name: "UC VS GINESYS",
		key: "UC_VS_GINESIS",
		path: "uc_vs_ginesys",
		department: departments.finanace_accounts,
	},
	ebo_store_pos_master: {
		name: "Store POS Master",
		key: "ebo_store_pos_master",
		path: "ebo_store_pos_master",
		department: departments.finanace_accounts,
	},
	ebo_payments: {
		name: "EBO Payment Working",
		key: "EBO_PAYMENTS",
		path: "ebo_payments",
		department: departments.finanace_accounts,
	},
	pos_reco: {
		name: "POS Collection Reco",
		key: "POS_RECO",
		path: "pos_reco/HOME",
		department: departments.finanace_accounts,
	},
	custom_queries: {
		name: "Custom Queries",
		key: "CUSTOM_QUERIES",
		path: "custom_queries",
		department: departments.buying_planning,
	},
	audience: {
		name: "Audience",
		key: "audience",
		path: "audience",
		department: departments.tech,
	},
	discount_master: {
		name: "Discount Master",
		key: "DISCOUNT_MASTER",
		path: "discount_master",
		department: departments.finanace_accounts,
	},
	mbo_sale_payment_working: {
		name: "MBO Sale Payment Working",
		key: "MBO_SALE_PAYMENT_WORKING",
		path: "mbo_sale_payment_working",
		department: departments.finanace_accounts,
	},
	designer_workspace: {
		name: "Designer Workspace",
		key: "DESIGNER_WORKSPACE",
		path: "designer_workspace",
		department: departments.tech,
	},
	fabric_sourcing_workspace: {
		name: "Fabric Sourcing Workspace",
		key: "FABRIC_SOURCING_WORKSPACE",
		path: "fabric_sourcing_workspace",
		department: departments.workspaces,
	},
	crm_workspace: {
		name: "CRM Workspace",
		key: "CRM_WORKSPACE",
		path: "crm_workspace",
		department: departments.workspaces,
	},
	cad_workspace: {
		name: "CAD Workspace",
		key: "CAD_WORKSPACE",
		path: "cad_workspace",
		department: departments.workspaces,
	},
	finance_workspace: {
		name: "Finance Workspace",
		key: "FINANCE_WORKSPACE",
		path: "finance_workspace",
		department: departments.tech,
	},
	it_workspace: {
		name: "IT Workspace",
		key: "IT_WORKSPACE",
		path: "it_workspace",
		department: departments.tech,
	},
	hr_workspace: {
		name: "HR Workspace",
		key: "HR_WORKSPACE",
		path: "hr_workspace",
		department: departments.tech,
	},
	studio_workspace: {
		name: "Studio Workspace",
		key: "STUDIO_WORKSPACE",
		path: "studio_workspace",
		department: departments.tech,
	},
	finance_payable_workspace: {
		name: "Finance Payable Workspace",
		key: "FINANCE_PAYABLE_WORKSPACE",
		path: "finance_payable_workspace",
		department: departments.tech,
	},
	mbo_sale_workspace: {
		name: "MBO Sale Workspace",
		key: "MBO_SALE_WORKSPACE",
		path: "mbo_sale_workspace",
		department: departments.tech,
	},
	ops_report_workspace: {
		name: "OPS Report Workspace",
		key: "OPS_REPORT_WORKSPACE",
		path: "ops_report_workspace",
		department: departments.tech,
	},
	exclusions: {
		name: "Exclusions",
		key: "EXCLUSIONS",
		path: "exclusions",
		department: departments.ecommerce,
	},
	sora: {
		name: "Sora",
		key: "Sora",
		path: "sora",
		department: departments.tech,
	},
	store_budget_tracker: {
		name: "Store Budget Tracker",
		key: "STORE_BUDGET_TRACKER",
		path: "store_budget_tracker",
		department: departments.finanace_accounts,
	},
	ebo_store_expenses: {
		name: "EBO Store Expenses",
		key: "EBO_STORE_EXPENSES",
		path: "ebo_store_expenses",
		department: departments.finanace_accounts,
	},
	refund_tracker: {
		name: "Refund Tracker",
		key: "REFUND_TRACKER",
		path: "refund_tracker",
		department: departments.finanace_accounts,
	},
	return_module: {
		name: "Return Module",
		key: "RETURN_MODULE",
		path: "return_module",
		department: departments.finanace_accounts,
	},
	wh_allocation: {
		name: "AXIS",
		key: "WH_ALLOCATION",
		path: "wh_allocation",
		department: departments.buying_planning,
	},
};
export const custom = {
	AXIS: { name: "AXIS", key: "AXIS" },
	RSM: { name: "Regional Sales Manager", key: "RSM" },
	NSM: { name: "National Sales Manager", key: "NSM" },
	ASM: { name: "Area Sales Manager", key: "ASM" },
	VM: { name: "VM", key: "VM" },
	MDM: { name: "MDM", key: "MDM" },
	COGS: { name: "COGS", key: "COGS" },
	WORKFORCEADMIN: { name: "WORKFORCE ADMIN", key: "WORKFORCEADMIN" },
	CASHCARDADMIN: { name: "CASHCARD ADMIN", key: "CASHCARDADMIN" },
	RARE_RABBIT: { name: "RARE RABBIT", key: "RARE_RABBIT" },
	RARE_RABBIT_FOC: { name: "RARE RABBIT FOC", key: "RARE_RABBIT_FOC" },
	RAREISM: { name: "RAREISM", key: "RAREISM" },
	RAREONES: { name: "RAREONES", key: "RAREONES" },
	RAREZ: { name: "RAREZ", key: "RAREZ" },
	THOR: { name: "THOR", key: "THOR" },
	GUILD: { name: "GUILD", key: "GUILD" },
	MBO: { name: "MBO", key: "MBO" },
	LFS: { name: "LFS", key: "LFS" },
	EBO: { name: "EBO", key: "EBO" },
	FINANCE_VIEWER: { name: "FINANCE VIEWER", key: "FINANCE_VIEWER" },
	FINANCE: { name: "FINANCE", key: "FINANCE" },
	BUYING_DATA: { name: "BUYING DATA", key: "BUYING_DATA" },
	STORE_ADMIN: { name: "Store Admin", key: "STORE_ADMIN" },
	AGREEMENT_ADMIN: { name: "AGREEMENT_ADMIN", key: "AGREEMENT_ADMIN" },
	BOARD: { name: "BOARD", key: "BOARD" },
	HR: { name: "HR", key: "HR" },
	WAREHOUSE: { name: "WAREHOUSE", key: "WAREHOUSE" },
	ONLINE: { name: "ONLINE", key: "ONLINE" },
	DW_VIEWER: { name: "DESIGNER WORKSPACE VIEWER", key: "DW_VIEWER" },
	FIN_VIEWER: { name: "FINANCE WORKSPACE VIEWER", key: "FIN_VIEWER" },
	HR_VIEWER: { name: "HR WORKSPACE VIEWER", key: "HR_VIEWER" },
	MBO_SALE_VIEWER: { name: "MBO WORKSPACE VIEWER", key: "MBO_SALE_VIEWER" },
	OPS_REPORT_VIEWER: { name: "OPS WORKSPACE VIEWER", key: "OPS_REPORT_VIEWER" },
	SUPPLIER_VIEWER: { name: "SUPPLIER VIEWER", key: "SUPPLIER_VIEWER" },
	THOR_SALES: { name: "THOR SALES", key: "THOR_SALES" },
	RAREISM_SALES: { name: "RAREISM SALES", key: "RAREISM_SALES" },
	ST_PICTORIAL: { name: "ST Pictorial (Sell Through)", key: "ST_PICTORIAL" },
	SIZE_CONTRIBUTION: { name: "Size Contribution", key: "SIZE_CONTRIBUTION" },
	DISPATCH_MAILER: { name: "Partner Dispatch Mailer", key: "DISPATCH_MAILER" },
	TARGET_VS_ACHIEVED: { name: "Target vs Achieved", key: "TARGET_VS_ACHIEVED" },
	PDF_TO_EXCEL: { name: "Line Sheet Convertor", key: "PDF_TO_EXCEL" },
	RARE_CHAT_BOT: { name: "Rare Chat Bot", key: "RARE_CHAT_BOT" },
	LOOKER_AGENT: { name: "Looker Agent", key: "LOOKER_AGENT" },
	SORA_WEEKLY_REPORT: { name: "SORA Weekly Report", key: "SORA_WEEKLY_REPORT" },
	VIEWER: { name: "VIEWER", key: "VIEWER" },
	EDITOR: { name: "EDITOR", key: "EDITOR" },
	PUBLISHER: { name: "PUBLISHER", key: "PUBLISHER" },
	BP_FINAL_APPROVER: { name: "BP Final Approver", key: "BP_FINAL_APPROVER" },
	BP_RM: { name: "BP Regional Manager", key: "BP_RM" },
	BP_ASM: { name: "BP Area Sales Manager", key: "BP_ASM" },
	BP_NSM: { name: "BP National Sales Manager", key: "BP_NSM" },
	BP_RARE_RABBIT: { name: "BP Rare Rabbit", key: "BP_RARE_RABBIT" },
	BP_RARE_ONES: { name: "BP Rare Ones", key: "BP_RARE_ONES" },
	BP_RAREISM: { name: "BP Rareism", key: "BP_RAREISM" },
	BP_EBO: { name: "BP EBO", key: "BP_EBO" },
	BP_MBO: { name: "BP MBO", key: "BP_MBO" },
	BP_LFS: { name: "BP LFS", key: "BP_LFS" },
	BP_D2C: { name: "BP D2C", key: "BP_D2C" },
	BP_MARKETPLACE: { name: "BP Marketplace", key: "BP_MARKETPLACE" },
};
export const externalTypes = {
	SUPPLIER: { name: "SUPPLIER", key: "SUPPLIER" },
	STORE: { name: "STORE", key: "STORE" },
	WAREHOUSE: { name: "WAREHOUSE", key: "WAREHOUSE" },
	ADYOGI: { name: "ADYOGI", key: "ADYOGI" },
	GUJRAT_SALE: { name: "GUJRAT SALE", key: "GUJRAT_SALE" },
};

export const userTypes = {
	internal: "INTERNAL",
	external: "EXTERNAL",
};

export const Roles = [
	{
		name: "VIEWER",
		key: "VIEWER",
	},
	{
		name: "EDITOR",
		key: "EDITOR",
	},

	{
		name: "PUBLISHER",
		key: "PUBLISHER",
	},
];
